import React from 'react';
import { Button } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import getPaymentMethod from '../CurrencyPay/getPaymentMethod';
import getPaymentStatus from '../CurrencyPay/getPaymentStatus';
import getTransactionId from '../CurrencyPay/getTransactionId';
import PaymentTypes from '../CurrencyPay/PaymentTypes';
import { Dispatch, iRootState } from '../redux/store';
import {
  CurrencyPayFinancingResponse,
  CurrencyPayResponse
} from '../redux/models/currencyPay';
import useUpdatePaymentStatus from '../CurrencyPay/useUpdatePaymentStatus';
import useOpenCurrencyPayWindowToPayTotal from '../useOpenCurrencyPayWindowToPayTotal';
import { QuoteStatuses, DialogNames } from '../constants';
import currentDate from '../currentDate';

const PayTotalQuote = function PayTotalQuote(): React.ReactElement {
  const dispatch = useDispatch<Dispatch>();
  const config = useSelector((state: iRootState) => state.currencyPay.config);
  const { updatePaymentStatus } = useUpdatePaymentStatus();
  const { openCurrencyPayWindow } = useOpenCurrencyPayWindowToPayTotal();
  const status = useSelector((state: iRootState) => state.quote.status);
  const showConfirmation = status !== QuoteStatuses.Accepted;
  const onSuccess = function handleOnSuccess(
    responseData: CurrencyPayResponse[]
  ): void {
    const paymentStatus = getPaymentStatus(responseData);
    const transactionId = getTransactionId(responseData);
    const paymentMethod = getPaymentMethod(responseData);
    updatePaymentStatus(paymentStatus, transactionId, paymentMethod);
  };
  const onFailure = function handleOnFailure(): void {
    updatePaymentStatus('Payment Unsuccessful', null, PaymentTypes.Unknown);
  };
  const onUnderReview = function handleOnUnderReview(
    responseData: CurrencyPayFinancingResponse
  ): void {
    const { applicationStatus, applicationId } = responseData;
    const paymentMethod = PaymentTypes.Financing;
    updatePaymentStatus(
      applicationStatus,
      applicationId.toString(),
      paymentMethod
    );
  };
  const onInit = function handleOnInit(): void {
    openCurrencyPayWindow();
  };
  const terms = useSelector((state: iRootState) => state.paymentTerms.terms);

  const onClick = function handleOnClick(): void {
    if (showConfirmation) {
      terms.forEach((element: { termOrder: number }) => {
        dispatch.paymentTerms.toggleSelectedTerm(element.termOrder);
      });
      dispatch.paymentTerms.toggleSelectedTerm(1);
      dispatch.quote.setQuoteStatus(QuoteStatuses.Accepted, currentDate());
      dispatch.dialog.setOpenDialog(DialogNames.SendFeedback);
    } else {
      terms.forEach((element: { termOrder: number }) => {
        dispatch.paymentTerms.toggleSelectedTerm(element.termOrder);
      });
      dispatch.currencyPay.resetFinancing({ ...config });
      dispatch.currencyPay.reinitialize({
        onInit,
        onSuccess,
        onFailure,
        onUnderReview
      });
      openCurrencyPayWindow();
    }
  };

  return (
    <Button
      color='primary'
      variant='outlined'
      onClick={onClick}
      style={{ minWidth: '150px' }}
    >
      <FormattedMessage id='payTotal' defaultMessage='Pay Total' />
    </Button>
  );
};
export default PayTotalQuote;
